// Cart page "apply coupon" changed location workaround
let applyDiscount = document.querySelector('.js-apply-discount');
if (document.querySelectorAll('.js-apply-discount').length > 0) {
  applyDiscount.addEventListener('click', function () {
    var couponCode = document.querySelector('.js-discount-code').value;
    document.querySelector('#coupon_code').value = couponCode;
    document.querySelector('button[name="apply_coupon"]').click();
  });
}

// Removes woocommerce error/success notice on close button click
function removeNotice() {
  let noticeClose = document.querySelector('.js-close-notice');
  if (document.querySelectorAll('.js-close-notice').length > 0) {
    noticeClose.addEventListener('click', (e) => {
      e.target.parentElement.parentElement.parentElement.remove();
    });
  }
}
removeNotice();

$(document.body).on('updated_cart_totals', function () {
  removeNotice();
});

let distributorRegionSelect = document.getElementById(
  'billing_distributor_region'
);
if (distributorRegionSelect) {
  jQuery('#billing_distributor_region option:first').attr('disabled', 'true');
  jQuery('#billing_distributor_region').select2();
}

let distributorCountriesSelect = document.getElementById('selected_country');
if (distributorCountriesSelect) {
  jQuery('#selected_country').select2();
}

/* eslint-disable */
$('#billing_distributor_region').on('select2:open', function () {
  jQuery('#billing_distributor_region option:first').attr('disabled', 'true');
  $('.select2-search--dropdown .select2-search__field').attr(
    'placeholder',
    trans.select2_search_placeholder
  );
});
$('#billing_distributor_region').on('select2:close', function () {
  $('.select2-search--dropdown .select2-search__field').attr(
    'placeholder',
    null
  );
});

jQuery('select2-wc_shipping_dpd_parcels_terminal-container').on(
  'click',
  function () {
    if (trans.select2_search_placeholder) {
      $('#wc_shipping_dpd_parcels_terminal').on('select2:open', function () {
        $('.select2-search--dropdown .select2-search__field').attr(
          'placeholder',
          trans.select2_search_placeholder
        );
      });
    }
  }
);
/* eslint-enable */

// Payment card formating (spaces every 4 numbers)
// jQuery(document).on('keyup', '#cardinity-card-number', function (e) {
//   var val = jQuery(this).val();
//   if (/\D/g.test(val)) {
//       val = val.replace(/\D/g, '');
//   }
//   var newval = '';
//   val = val.replace(/\s/g, '');
//   for(var i = 0; i < val.length; i++) {
//       if(i%4 == 0 && i > 0) newval = newval.concat(' ');
//       newval = newval.concat(val[i]);
//   }
//   jQuery(this).val(newval);
// });

let productOrderSeelct = document.querySelector(
  '.woocommerce .woocommerce-ordering select'
);
if (productOrderSeelct) {
  jQuery('.woocommerce .woocommerce-ordering select').select2();
}

if (
  jQuery(
    '.page-template-template-contacts form.wpcf7-form .wpcf7-form-control-wrap select'
  ).length > 0
) {
  jQuery(
    '.page-template-template-contacts form.wpcf7-form .wpcf7-form-control-wrap select'
  ).select2();
}

// Checkout "place order" button only active if terms accepted
var placeOrderBtn = jQuery('[name="woocommerce_checkout_place_order"]');
setTimeout(function () {
  jQuery('[name="woocommerce_checkout_place_order"]').each(function () {
    jQuery(this).attr('disabled', 'disabled');
    jQuery(this).addClass('disabled');
  });
}, 1000);

jQuery(document).on('change', '#terms', function () {
  var ischecked = jQuery(this).is(':checked');
  if (!ischecked) {
    placeOrderBtn.attr('disabled', 'disabled');
    placeOrderBtn.addClass('disabled');
  } else {
    placeOrderBtn.removeAttr('disabled');
    placeOrderBtn.removeClass('disabled');
  }
});

jQuery('input#invoice_trigger')
  .change(function () {
    if (!this.checked) {
      // HIDE IF NOT CHECKED
      jQuery('#billing_company_name_field').fadeOut();
      jQuery('#billing_company_name_field').removeClass('validate-required');
      jQuery('#billing_company_name input').val('');
      jQuery('#billing_company_code_field').fadeOut();
      jQuery('#billing_company_code_field').removeClass('validate-required');
      jQuery('#billing_company_code input').val('');
      jQuery('#billing_company_vat_code_field').fadeOut();
      jQuery('#billing_company_vat_code_field').removeClass(
        'validate-required'
      );
      jQuery('#billing_company_vat_code input').val('');
    } else {
      // SHOW IF CHECKED
      jQuery('#billing_company_name_field').fadeIn();
      jQuery('#billing_company_name_field').addClass('validate-required');
      jQuery('#billing_company_code_field').fadeIn();
      jQuery('#billing_company_code_field').addClass('validate-required');
      jQuery('#billing_company_vat_code_field').fadeIn();
      jQuery('#billing_company_vat_code_field').addClass('validate-required');
    }
  })
  .change();

jQuery(document.body).on('updated_checkout', function () {
  if (!jQuery('#billing_country').val()) {
    jQuery('#billing_country').val('LT').trigger('change');
  }

  setTimeout(() => {
    updateShipping();
  }, 10);
});

function updateShipping() {
  jQuery.ajax({
    url: '/wp/wp-admin/admin-ajax.php',
    type: 'GET',
    data: { action: 'updateShippingMethods' },
    beforeSend: function () {
      jQuery('.woocommerce ul#shipping_method').addClass('loader');
    },
    success: (response) => {
      if (response.success) {
        document.querySelector('.woocommerce ul#shipping_method').innerHTML =
          response.data;

        // If select element exists apply SELECT2
        if (
          document.querySelectorAll('.woocommerce ul#shipping_method select')
            .length > 0
        ) {
          setTimeout(function () {
            jQuery('.woocommerce ul#shipping_method select').select2();
          }, 100);
        }

        jQuery('.woocommerce ul#shipping_method').removeClass('loader');
        setTimeout(function () {
          jQuery('select.omnivalt_terminal').select2();

          if (trans.select2_search_placeholder) {
            $('#wc_shipping_dpd_parcels_terminal').on(
              'select2:open',
              function () {
                $('.select2-search--dropdown .select2-search__field').attr(
                  'placeholder',
                  trans.select2_search_placeholder
                );
              }
            );
          }
        }, 1000);
      }
    },
    error: (error) => {
      console.error(error);
    },
  });
}

let reviewShow = document.querySelector('.js-show-review');
if (document.querySelectorAll('.js-show-review').length > 0) {
  reviewShow.addEventListener('click', (e) => {
    let review = document.querySelector('.js-review');
    review.classList.toggle('active');
    e.target.classList.toggle('active');
  });
}

if (document.querySelectorAll('form.payment_select #selected_country').length > 0) {
  jQuery('.js-distributor-payment-methods').addClass('loading');
}

setTimeout(function () {

  var countrySelect = jQuery('form.payment_select #selected_country');

  // if (
  //   document.querySelectorAll('form.payment_select #selected_country').length > 0
  // ) {
  //   updateDistributorPaymentOptions('');
  // }

  let selectedCountry = jQuery('form.payment_select #selected_country').val();
  updateDistributorPaymentOptions(selectedCountry);

  countrySelect.on('change', function () {
    let selectedCountry = jQuery('form.payment_select #selected_country').val();
    updateDistributorPaymentOptions(selectedCountry);
  });

}, 2000);

function updateDistributorPaymentOptions(selectedCountry) {
  jQuery.ajax({
    url: '/wp/wp-admin/admin-ajax.php',
    type: 'POST',
    data: {
      action: 'updateDistributorPaymentOptions',
      selectedCountry: selectedCountry,
    },
    beforeSend: function () {
      jQuery('.js-distributor-payment-methods').addClass('loading');
    },
    success: (response) => {
      if (
        document.querySelectorAll('.js-distributor-payment-methods').length > 0
      ) {
        document.querySelector('.js-distributor-payment-methods').innerHTML =
          response.data;
      }
      jQuery('.js-distributor-payment-methods').removeClass('loading');
    },
    error: (error) => {
      console.error(error);
    },
  });
}

// Show/hide paypal payment buttons according to selected paypal method is or not
setTimeout(function () {
  if (document.querySelectorAll('#woo_pp_ec_button_checkout').length > 0) {
    let paypalButtons2 = document.getElementById('woo_pp_ec_button_checkout');
    paypalButtons2.style.display = 'none';
  }

  ShowHidePaypal();
}, 1000);

jQuery(document).on('update_checkout', function () {
  ShowHidePaypal();
});

jQuery(document).on('updated_shipping_method', function () {
  ShowHidePaypal();
});

function ShowHidePaypal() {
  const mobilePlaceOrder = document.querySelector(
    '.js-mobile-place-order #place_order'
  );
  const paypalButtonsWrapper = document.querySelector('.ppc-button-wrapper');

  if (
    document.querySelectorAll(
      'li.wc_payment_method.payment_method_ppcp-gateway'
    ).length > 0 &&
    document.querySelectorAll('#ppc-button').length > 0
  ) {
    let paypalButtons = document.getElementById('ppc-button');
    let placeOrderButton = document.querySelector(
      'body.woocommerce-checkout form.woocommerce-checkout [name="woocommerce_checkout_place_order"]'
    );

    paypalButtons.classList.remove('active');

    if (
      document.querySelector(
        'li.wc_payment_method.payment_method_ppcp-gateway input'
      ).checked
    ) {
      paypalButtons.classList.add('active');
      placeOrderButton.classList.add('hidden');

      if (window.innerWidth < 768) {
        jQuery('.ppc-button-wrapper').insertAfter(
          '.js-mobile-paypal-container'
        );
        mobilePlaceOrder.classList.add('hidden');
        document
          .querySelector('.js-mobile-place-order .ppc-button-wrapper')
          .classList.remove('hidden');
      }
    } else {
      placeOrderButton.classList.remove('hidden');

      if (window.innerWidth < 768) {
        mobilePlaceOrder.classList.remove('hidden');
        document
          .querySelector('.js-mobile-place-order .ppc-button-wrapper')
          .classList.add('hidden');
      }
    }
  }

  if (
    document.querySelectorAll('li.wc_payment_method.payment_method_ppec_paypal')
      .length > 0 &&
    document.querySelectorAll('#woo_pp_ec_button_checkout').length > 0
  ) {
    let paypalButton = document.getElementById('woo_pp_ec_button_checkout');
    paypalButton.style.display = 'none';
    document.querySelector(
      '[name="woocommerce_checkout_place_order"]'
    ).style.display = 'block';

    if (
      document.querySelector(
        'li.wc_payment_method.payment_method_ppec_paypal input'
      ).checked
    ) {
      paypalButton.style.display = 'block';
      document.querySelector(
        '[name="woocommerce_checkout_place_order"]'
      ).style.display = 'none';
    }
  }
}

// Prevents distributor form submit if no fields selected
if (
  document.querySelectorAll(
    '.page-template-template-payment-select #payment_select'
  ).length > 0
) {
  const paymentSelectForm = document.getElementById('payment_select');
  paymentSelectForm.addEventListener(
    'submit',
    function (e) {
      let selectedCountry = document.getElementById('selected_country').value;
      let paymentMethods = document.querySelectorAll(
        '.js-distributor-payment-methods .payment_method'
      );
      let paymentSelectErrorWrapper = document.querySelector(
        '.js-payment-select-error-wrapper'
      );
      let isPaymentSelected = false;

      for (let index = 0; index < paymentMethods.length; index++) {
        const paymentMethod = paymentMethods[index];
        if (paymentMethod.querySelector('input').checked) {
          isPaymentSelected = true;
        }
      }

      paymentSelectErrorWrapper.classList.add('hidden');
      paymentSelectErrorWrapper
        .querySelector('.country')
        .classList.add('hidden');
      paymentSelectErrorWrapper
        .querySelector('.distributor')
        .classList.add('hidden');

      if (selectedCountry == '' || isPaymentSelected == false) {
        paymentSelectErrorWrapper.classList.remove('hidden');
        if (selectedCountry == '') {
          paymentSelectErrorWrapper
            .querySelector('.country')
            .classList.remove('hidden');
        }
        if (isPaymentSelected == false) {
          paymentSelectErrorWrapper
            .querySelector('.distributor')
            .classList.remove('hidden');
        }
        e.preventDefault();
        e.stopPropagation();
      }
    },
    false
  );
}

// Removes terms and conditions checkout link content toggle in same page
let termsLink = document.querySelectorAll(
  '.woocommerce-terms-and-conditions-link'
);
if (termsLink.length > 0) {
  for (let i = 0, len = termsLink.length; i < len; i++) {
    termsLink[i].classList.remove('woocommerce-terms-and-conditions-link');
  }
}

function payseraSelect() {
  let payseraCountrySelect = document.getElementById('paysera_country');
  if (payseraCountrySelect) {
    jQuery('#paysera_country').select2();
  }
}

payseraSelect();

jQuery(document).on('update_checkout', function () {
  payseraSelect();
});

jQuery(document).on('updated_checkout', function () {
  payseraSelect();
});

jQuery(document).on('updated_shipping_method', function () {
  payseraSelect();
});

// Validates VAT code on input change
const vatField = document.getElementById('billing_company_vat_code_field');
const invoiceTrigger = document.getElementById('invoice_trigger_field');

if (vatField) {
  vatField.addEventListener('change', () => {
    if (!jQuery('#billing_country').val()) {
      jQuery('#billing_country').val('LT').trigger('change');
    }
    jQuery(document.body).trigger('update_checkout');
  });
}

if (invoiceTrigger) {
  invoiceTrigger.addEventListener('change', () => {
    if (!jQuery('#billing_country').val()) {
      jQuery('#billing_country').val('LT').trigger('change');
    }
    jQuery(document.body).trigger('update_checkout');
  });
}
